import './styles/styles.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { isElectronRuntime } from './platform/electron';

import LoginPage from './core/auth/loginPage';
import MainLayout from './app/layout/MainLayout';
import ThemeModeProvider from './theme/ThemeModeProvider';
// Legacy dark overrides stay last until all feature colors consume theme tokens.

const Router = isElectronRuntime() ? HashRouter : BrowserRouter;

function RequireAuth({ children }) {
  const location = useLocation();
  const rawUser = localStorage.getItem('currentUser');
  const token = localStorage.getItem('authToken');

  if (!rawUser || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const user = JSON.parse(rawUser);
    if (!user || !user.id) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  } catch (err) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ThemeModeProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<RequireAuth><MainLayout /></RequireAuth>} />
        </Routes>
      </ThemeModeProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
